module.exports = __webpack_public_path__ + "static/media/edit-section.b15096a9.svg";